import { render, staticRenderFns } from "./AnimWords.vue?vue&type=template&id=ed018eec&scoped=true"
import script from "./AnimWords.vue?vue&type=script&lang=js"
export * from "./AnimWords.vue?vue&type=script&lang=js"
import style0 from "./AnimWords.vue?vue&type=style&index=0&id=ed018eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed018eec",
  null
  
)

export default component.exports